import React, { memo } from 'react'

// Skeleton loading
import Skeleton from 'react-loading-skeleton';

function ProductList__loadingSkeleton() {
    return (
        <div className="col-sm-6 col-lg-4 mb-3">
            <Skeleton count={1} height={400} width={"100%"} />

            <Skeleton
                count={1}
                height={20}
                width={200}
                className="d-block mx-auto"
                style={{ marginTop: 15 }}
            />
            <Skeleton
                count={1}
                height={35}
                width={100}
                className="d-block mx-auto"
                style={{ marginTop: 15 }}
            />
            <Skeleton
                count={1}
                height={40}
                width={200}
                className="d-block mx-auto"
                style={{ marginTop: 15 }}
            />
        </div>
    )
}

export default memo(ProductList__loadingSkeleton)